import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {
      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0,0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')


      this.draw_DonutChart()
      if(this.icon.display == 'Y') this.draw_Icon()
      if(this.gauge.display == 'Y') this.draw_Gauges()
      if(this.legends.display == 'Y') this.draw_Legends()


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  }
}